var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"campaign"},[_c('Header',{attrs:{"user":_vm.user}}),_c('main',{staticClass:"main animated fadeIn faster",class:{ 'expand-main' : _vm.isMenuCollapse }},[_c('DashboardAdmin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }